import * as React from 'react';
import EDTooltip from '../../Tooltip/EDTooltip';

/** These props are used in LocalMenu, which itterates over children.
 * It's a bit backwards, but it's helpfull to have the functionality for different categories in one place.
 */
interface IProps {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  disabledReason?: React.ReactNode;
  category?: string;
  tooltip?: string;
}

const MenuButtonItem: React.FC<IProps> = ({
  children,
  tooltip,
  disabled,
  disabledReason,
}) => {
  if (disabled && disabledReason) {
    return (
      <EDTooltip title={disabledReason} enableClickOnTouch>
        <>{children}</>
      </EDTooltip>
    );
  }
  if (tooltip) {
    return (
      <EDTooltip title={tooltip}>
        <>{children}</>
      </EDTooltip>
    );
  }
  return <>{children}</>;
};

export default MenuButtonItem;
